// 用户管理模块国际化 - 中文
export default {
  title: '用户管理',
  description: '管理系统用户账户，包括用户信息、权限和状态',

  // 字段
  fields: {
    username: '用户名',
    email: '邮箱地址',
    phone: '手机号',
    company: '所属公司',
    role: '用户角色',
    status: '用户状态',
    lastLogin: '最后登录',
    createTime: '创建时间',
    userId: '用户ID',
    newPassword: '新密码',
    currentStatus: '当前状态'
  },

  // 统计
  stats: {
    totalUsers: '用户总数',
    activeUsers: '活跃用户',
    inactiveUsers: '禁用用户',
    pendingUsers: '待激活用户'
  },

  // 状态
  status: {
    title: '用户状态',
    all: '全部状态',
    active: '正常',
    inactive: '禁用',
    pending: '待激活',
    unknown: '未知'
  },

  // 角色
  roles: {
    all: '全部角色',
    superAdmin: '超级管理员',
    user: '普通用户',
    unknown: '未知'
  },

  // 操作
  actions: {
    addUser: '添加用户',
    editUser: '编辑用户',
    userDetail: '用户详情',
    detail: '详情',
    enable: '启用',
    disable: '禁用',
    resetPassword: '重置密码',
    bindCompany: '绑定企业',
    toggleStatus: '状态切换确认'
  },

  // 表单
  forms: {
    searchPlaceholder: '搜索用户名、邮箱或公司',
    statusFilter: '状态筛选',
    roleFilter: '角色筛选',
    usernamePlaceholder: '请输入用户名',
    usernameRequired: '请输入用户名',
    emailPlaceholder: '请输入邮箱地址',
    emailRequired: '请输入邮箱地址',
    emailInvalid: '请输入有效的邮箱地址',
    phonePlaceholder: '请输入手机号',
    phoneRequired: '请输入手机号',
    companyPlaceholder: '请输入所属公司',
    companyRequired: '请输入所属公司',
    rolePlaceholder: '请选择用户角色',
    roleRequired: '请选择用户角色',
    statusPlaceholder: '请选择用户状态',
    statusRequired: '请选择用户状态'
  },

  // 消息提示
  messages: {
    showAllUsers: '显示全部用户',
    filterActiveUsers: '筛选活跃用户',
    filterInactiveUsers: '筛选禁用用户',
    filterPendingUsers: '筛选待激活用户',
    searchSuccess: '搜索完成',
    refreshSuccess: '数据已刷新',
    addSuccess: '用户添加成功',
    updateSuccess: '用户信息已更新',
    deleteSuccess: '用户 {username} 已删除',
    statusToggled: '用户 {username} 已{status}',
    passwordResetSuccess: '用户 {username} 密码重置成功',
    resetPasswordWarning: '密码重置警告',
    resetPasswordDesc: '即将为用户 {username} 重置密码，新密码将随机生成。',
    disableWarning: '禁用后，该用户将无法登录系统，所有正在进行的操作将被中断。',
    enableInfo: '启用后，该用户将恢复正常的系统访问权限，可以重新登录使用系统。',
    autoFilterCompany: '已自动筛选企业：{company}'
  }
}